import React from "react";
import DepositCalculatorHead from "../components/deposits-calculator/calculator-head/Main";
import { UseDepositCalculatorQuery } from "./api/DepositCalculatorApi";

const DepositsCalculator = ({ keyword }) => {
    const data = UseDepositCalculatorQuery(keyword)
  const { calculator_body, calculator_head } = data !== undefined && data;
  return (
    data !== undefined && (
      <div>
        <DepositCalculatorHead headData={calculator_head} bodyData={calculator_body} keyword={keyword}/>
      </div>
    )
  );
};

export default DepositsCalculator;
